// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gu1DHlRzf1eoHSuwHXhn {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
}

.rlM1DwS_Oxls1Gy8cCxs {
  background-color: #d7bb8e;
  border: 4px inset #d9a066;
  padding: 1.5rem;
  color: #13121d;
  width: 680px;
  cursor: initial;
  font-family: Allura;
  font-weight: bold;
  font-size: 32px;
}
.rlM1DwS_Oxls1Gy8cCxs > *:not(:first-child) {
  margin-top: 2rem;
}

.TUdhNUpXZKvwkv5mGM6X {
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/UIRoot.sass"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oCAAA;AACD;;AACA;EACC,yBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAED;AADC;EACC,gBAAA;AAGF;;AADA;EACC,cAAA;AAID","sourcesContent":[".uiRoot\n\tcolor: white\n\tdisplay: flex\n\talign-items: center\n\tjustify-content: center\n\tcursor: pointer\n\tbackground-color: rgba(0, 0, 0, 0.5)\n\n.letter\n\tbackground-color: #d7bb8e\n\tborder: 4px inset #d9a066\n\tpadding: 1.5rem\n\tcolor: #13121d\n\twidth: 680px\n\tcursor: initial\n\tfont-family: Allura\n\tfont-weight: bold\n\tfont-size: 32px\n\t> *:not(:first-child)\n\t\tmargin-top: 2rem\n\n.signature\n\tcolor: inherit\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uiRoot": `Gu1DHlRzf1eoHSuwHXhn`,
	"letter": `rlM1DwS_Oxls1Gy8cCxs`,
	"signature": `TUdhNUpXZKvwkv5mGM6X`
};
export default ___CSS_LOADER_EXPORT___;
